import React from 'react';
import { WEBSITE_NAME } from '../../utils/constants';

const CTActionSection = () => {
  return (
    <section className="py-8 sm:py-12 md:py-16 bg-gradient-to-r from-blue-600 to-indigo-700">
      <div className="container mx-auto px-4 text-center">
        <div className="inline-block bg-yellow-400 text-yellow-900 px-3 py-1 sm:px-4 sm:py-1 rounded-full text-xs sm:text-sm font-bold mb-4 sm:mb-6">
          ⚡ LIMITED TIME OFFER
        </div>
        
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 leading-tight">
          Give your business the gift of growth
        </h2>
        
        <p className="text-base sm:text-lg md:text-xl text-blue-100 max-w-3xl mx-auto mb-6 sm:mb-8 md:mb-10 px-2 sm:px-0 leading-relaxed">
          Unlock the tools that power faster decisions, smarter ads, and stronger performance when it matters most.
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 mb-8 sm:mb-10 md:mb-12 px-2 sm:px-0">
          <button className="bg-white text-blue-600 px-6 py-3 sm:px-8 sm:py-4 md:px-10 md:py-4 rounded-lg font-bold text-sm sm:text-base md:text-lg hover:bg-gray-100 transition shadow-lg w-full sm:w-auto">
            Claim your 35% discount
          </button>
          <button className="bg-transparent border-2 border-white text-white px-6 py-3 sm:px-8 sm:py-4 md:px-10 md:py-4 rounded-lg font-bold text-sm sm:text-base md:text-lg hover:bg-white/10 transition w-full sm:w-auto">
            Start free trial
          </button>
        </div>
        
        {/* Success Metrics */}
        <div className="bg-white/10 backdrop-blur-sm rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 max-w-4xl mx-auto mb-8 sm:mb-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            <div className="text-center">
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-1 sm:mb-2">30-Day</div>
              <div className="text-xl sm:text-2xl md:text-3xl font-bold text-yellow-300">$3,989,559.89</div>
              <p className="text-blue-200 mt-1 sm:mt-2 text-sm sm:text-base">Revenue Generated</p>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-1 sm:mb-2">9,764</div>
              <p className="text-blue-200 text-sm sm:text-base">Units Sold</p>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-1 sm:mb-2">Samsung P2D</div>
              <p className="text-blue-200 text-sm sm:text-base">Top Performing Product</p>
            </div>
          </div>
        </div>
        
        <div className="mt-8 sm:mt-10 md:mt-12">
          <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-6 sm:mb-8">YOUR WINNING SOLUTION</h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 max-w-4xl mx-auto px-2 sm:px-0">
            <div className="text-center">
              <div className="text-3xl sm:text-4xl md:text-5xl mb-3 sm:mb-4">🚀</div>
              <h4 className="text-base sm:text-lg md:text-xl font-bold text-white mb-1 sm:mb-2">Start selling products</h4>
              <p className="text-blue-200 text-sm sm:text-base">in any marketplace</p>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl md:text-5xl mb-3 sm:mb-4">📈</div>
              <h4 className="text-base sm:text-lg md:text-xl font-bold text-white mb-1 sm:mb-2">Grow your business</h4>
              <p className="text-blue-200 text-sm sm:text-base">and build steady income</p>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl md:text-5xl mb-3 sm:mb-4">🤖</div>
              <h4 className="text-base sm:text-lg md:text-xl font-bold text-white mb-1 sm:mb-2">Operate with ease</h4>
              <p className="text-blue-200 text-sm sm:text-base">and tailored automations</p>
            </div>
          </div>
        </div>
        
        <p className="text-white text-lg sm:text-xl md:text-2xl font-bold mt-8 sm:mt-10 md:mt-12 mb-4 sm:mb-6 md:mb-8 px-2 sm:px-0">
          See how sellers are succeeding with {WEBSITE_NAME}
        </p>
        
        <button className="bg-white text-blue-600 px-8 py-3 sm:px-10 sm:py-4 md:px-12 md:py-4 rounded-full font-bold text-base sm:text-lg md:text-xl hover:bg-gray-100 transition shadow-2xl w-full sm:w-auto">
          Sign up for free
        </button>
      </div>
    </section>
  );
};

export default CTActionSection;